import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, NgModel, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment-timezone'
import { AppState } from '../app.service';
import { Client } from '../client/client.model';
import { CordovaService } from '../cordova.service';
import { NotificationService } from '../notification/notification.service';
import { PathGroup } from '../path-group/path-group.model';
import { PathGroupService } from '../path-group/path-group.service';
import { SessionService } from '../session/session.service';
import { ThemeService } from '../theme/theme.service';
import { SignUpForm, User } from '../user/user.model';
import { UserService } from '../user/user.service';
import { environment } from '../../environments/environment'
import { SpinnerService } from '../spinner.service';
import { I18n } from '../i18n.service';
import { IonInput, ModalController, Platform ,PopoverController} from '@ionic/angular';
import { PopoverComponent } from '../shared/popover/popover.component';
import { SignupPopoverComponent } from '../signup-popover/signup-popover.component';
import { ToasterService } from '../toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { AlertWrongCodeComponent } from '../alert-wrong-code/alert-wrong-code.component';
import { CustomValidators } from '../components/edit-profile/custom-validators';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AlertSelectPathComponent } from '../alert-select-path/alert-select-path.component';
import { AnimationsService } from '../shared/animations.service';
import { SignInService } from '../sign-in/sign-in.service';
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
import { AlertPathSelectV2Component } from '../alert-path-select-v2/alert-path-select-v2.component';
import mixpanel from 'mixpanel-browser';

import { Constants } from '../constants/constants';
export interface SignUpByForm{
  [signUpByForm: string]: any
}

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  animations: [
    trigger('fadeInOut', [
      state('in', style({ opacity: 1, height: 50 })),
      transition(':enter', [
        style({ opacity: 0, height: 'auto' }),
        animate('0.5s ease-out')
      ]),
      transition(':leave', [
        animate('0.5s ease-in', style({ opacity: 0, height: 'auto' }))
      ])
    ]),
    trigger('fadeInOut2', [
      state('in', style({ opacity: 1, transform: 'scale(1)', maxHeight: '1000px' })),
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.95)', maxHeight: 0 }),
        animate('0.5s ease', style({ opacity: 1, transform: 'scale(1)', maxHeight: '1000px', height: '*' }))
      ]),
      transition(':leave', [
        animate('0.5s ease', style({ opacity: 0, transform: 'scale(0.95)', maxHeight: 0, height: 0 }))
      ])
    ]),
    trigger('fadeInOutPasswordValidator', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-10px)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 0, transform: 'translateY(-10px)' }))
      ])
    ]),
    trigger("keyboardAnimation", [
      state("visible", style({ transform: "translateY(-50px)", opacity: 1 })),
      state("hidden", style({ transform: "translateY(0px)", opacity: 0 })),
      transition("hidden => visible", animate("300ms ease-in")),
      transition("visible => hidden", animate("300ms 100ms ease")),
    ]),
  ]
})
export class SignUpComponent implements OnInit {
  @ViewChild('firstName') firstName: NgModel
  @ViewChild('lastName') lastName: NgModel
  @ViewChild('email') email: NgModel
  @ViewChild('group') group: NgModel
  validate = ['firstName', 'lastName', 'email', 'group']
  valid: () => boolean
  onCordova: boolean = false // LUMBA-982
  fnameInputFocusTab = false
  lnameInputFocusTab = false
  pwdInputFocusTab = false
  passwordConfirmationTab = false
  signupCodeInputFocusTab = false
  environment: any
  pathGroupName: string
  queryParamSubDomain: string
  currentPathGroup: PathGroup
  client: Client
  signUpForm: SignUpForm = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordConfirmation: '',
    timezone: '',
    confirm: false,
    signupCode: '',
  }

  activePathId?: number

  expired: boolean
  notStarted: boolean

  clientBackgroundImageUrl: string
  colours: any
  nameSignUp: string
  loading = false
  imageStyle: object = { 'background-image': 'url(assets/images/default-logo.jpg)' }
  clientLogoImageUrlNew  = 'assets/images/default-logo.jpg'
  backgroundStyle: object = {'background-image': 'url(assets/images/default-background.jpg)'}

  clientLoginLogoImageUrl: string
  public signUpByForm: SignUpByForm
  isMobile: boolean
  clientId: any 
  termsURL: any
  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';
  passwordType1: string = 'password';
  passwordIcon1: string = 'eye-off';
  clientImage: any
  isFname = true
  isLname = false
  isPwd = false
  
  isConfirmPwd = false
  isConfirmPwdFocused = false
  isSUCode = false
  pathGroups: any
  @ViewChild('firstName', { static: false }) fName: IonInput;
  @ViewChild('signupCodeMobile', { static: false }) signupCodeMobile: IonInput;
  @ViewChild('signupCodeWeb', { static: false }) signupCodeWeb: IonInput;
  public frmSignup: UntypedFormGroup;
  passwordValidated = false
  filteredPathsGroups = []
  cohorts: any
  isCohort: any
  modalClosed = true;
  showVerification = false
  showSignUp = true
  verifyEmail: string
  isAndroidTablet: boolean;
  constants = Constants;
  translatedSignupAgreemetText;
  constructor(
    private appState: AppState,
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private pathGroupService: PathGroupService,
    private sessionService: SessionService,
    private themeService: ThemeService,
    private notificationService: NotificationService,
    private i18n: I18n,
    public cordovaService: CordovaService,
    public keyboard: Keyboard,
    private spinnerService: SpinnerService,
    private popover:PopoverController,
    private toasterService: ToasterService,
    private matDialog: MatDialog,
    private fb: UntypedFormBuilder,
    private modalController: ModalController,
    private animationService: AnimationsService,
    private singinService: SignInService,
    private platform: Platform, 
  ) {
    this.environment = environment
    this.pathGroupName = this.route.snapshot.paramMap.get('pathGroupName')
    this.signUpForm.timezone = moment.tz.guess()
    this.translatedSignupAgreemetText = this.i18n.t(`By continuing, you agree to ${this.constants.appName}’s`);
    this.onCordova = this.cordovaService.onCordova
    this.isMobile = this.appState.get('isMobile')
    this.termsURL = 'https://api-images.kyper.1st90.com/1st90/1st90_Terms+and+Conditions.pdf'
    this.clientImage = this.appState.get('clientImage')
    this.frmSignup = this.createSignupForm(); 
    this.isAndroidTablet = this.platform.is('mobileweb') && this.platform.is('tablet') && this.sessionService.isTabletDevice();
    this.appState.set('signupData',undefined)
    console.log('signUpForm in constructor:', this.appState.get('signUpForm'));
    if(appState.get('signUpForm')){
      this.signUpForm = this.appState.get('signUpForm')
      this.frmSignup.controls.password.setValue(this.signUpForm.password);
    }
    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.fName.setFocus()      
    }, 10);
    // this.resizeHeight();
    // this.restoreResizeHeight();
  }

  ngOnInit() {   
    this.resizeHeight();
    this.restoreResizeHeight();

    let email = this.route.snapshot.queryParamMap.get(
      'newUserEmail'
    )
    if(email){
      this.signUpForm.email = email
    }
    this.checksignupcode(this.signUpForm.email,this.clientId,this.onCordova)
    if (localStorage.getItem('token')) {
      this.router.navigate(['/main'])
    }
    if (!this.pathGroupName) { // LUMBA-982
      this.clientBackgroundImageUrl = this.themeService?.themeData?.clientBackgroundImageUrl
      this.setImageStyles()  // LUMBA-1408

      this.spinnerService.off()
      return
    }
    this.spinnerService.off();
    // this.pathGroupService.getPathGroupByName(this.pathGroupName).subscribe(pathGroup => {
    //     this.client = pathGroup.client
    //     this.setStyles()
        
    //     // LUMBA-982
    //     if (pathGroup.client.backgroundImageUrl) {
    //       localStorage.setItem('clientBackgroundImageUrl', pathGroup.client.backgroundImageUrl)
    //       this.clientBackgroundImageUrl = this.client.backgroundImageUrl
    //     } else {
    //       this.clientBackgroundImageUrl = this.themeService.themeData.clientBackgroundImageUrl
    //     }
    //     if (pathGroup.client.imageUrl || pathGroup?.client.backgroundImageUrl) {
    //       localStorage.setItem('clientLogoImageUrl', pathGroup.client.imageUrl??pathGroup?.client?.backgroundImageUrl)
    //     }
    //     this.currentPathGroup = pathGroup
    //     //
    //     const now = new Date
    //     this.nameSignUp = this.currentPathGroup.getCustomText('st_su')
    //     this.colours = this.currentPathGroup.colours
    //     this.themeService.apply(this.currentPathGroup, this.client)  // LUMBA-1440
    //     if (now < new Date(this.currentPathGroup.starts)) {
    //       this.notStarted = true
    //     }
    //     if (now > new Date(this.currentPathGroup.ends)) {
    //       this.expired = true
    //     }
    //     this.spinnerService.off()
    //   },
    //   () => {
    //     this.spinnerService.off()
    //     this.router.navigate([`/not-found`])

    //   })     

      this.getclientIdURL()

      this.setClientBackground()    

  }

  resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
         const mobileLoginScreens = document.querySelectorAll('.mobile-login-screen');
          mobileLoginScreens.forEach((screen) => {
            // screen.setAttribute('style', `height: calc(100vh - 200px);`);
            screen.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px); overflow-y: scroll;`);
          });
          console.log('keyboard show');
       });
  }

  restoreResizeHeight(){
    this.keyboard.onKeyboardDidHide().subscribe(() => {
      const mobileLoginScreens = document.querySelectorAll('.mobile-login-screen');
      mobileLoginScreens.forEach((screen) => {
          screen.setAttribute('style', `height: 100vh`);
      });
      console.log('keyboard hide');
    })
  }

//   scrollToInput(input: HTMLElement) {
//     const inputPosition = input.getBoundingClientRect().top + window.scrollY;
//     const desiredPosition = inputPosition - (window.innerHeight / 2) + (input.offsetHeight / 2);
//     const container = document.querySelector('.mobile-login-screen') as HTMLElement;
//     container.scrollTo({
//         top: desiredPosition,
//         behavior: 'smooth'
//     });
// }

scrollToInput(input: HTMLElement) {
  const inputPosition = input.getBoundingClientRect().top + window.scrollY; 
  const desiredPosition = inputPosition - 100; 
  const container = document.querySelector('.mobile-login-screen') as HTMLElement; 
  container?.scrollTo({
      top: desiredPosition,
      behavior: 'smooth'
  });
}


  isEngagementClient(): boolean {
    return this.client && this.client.name && this.client.name.toLowerCase() === 'engagement'
  }

  onTextareaFocus() {
    let id = document.getElementsByClassName("login-box");
    let id2  = document.getElementsByClassName("web-singup-overflow");
    if (id) {
      console.log("test bottomheight");
      for (let i = 0; i < id?.length; i++) {
         id[i]?.setAttribute(
           "style",
           "margin-top:2%; margin-bottom:55px; overflow-y:scroll;height:calc(100vh - 130px);"
         );
      }
      
    }
    if (id2) {
      for (let i = 0; i < id2?.length; i++) {
         id2[i]?.setAttribute(
           "style",
           "max-height:85vh;"
         );
      }
      
    }
  }

    onTextareaBlur() {
    let id = document.getElementsByClassName("login-box");
    let id2  = document.getElementsByClassName("web-singup-overflow");
    if (id) {
      for (let i = 0; i < id?.length; i++) {
         id[i]?.setAttribute(
           "style",
           "margin-top:21%; margin-bottom:5px; overflow-scroll:none; height:100%;"
         );
      }
      
    }
    if (id2) {
      for (let i = 0; i < id2?.length; i++) {
         id2[i]?.setAttribute(
           "style",
           "max-height:63vh; overflow-y:auto;"
         );
      }
      
    }
  }
  // LUMBA-982  // LUMBA-1410
  goToPrev() {
    if (this.pathGroupName) {
      this.appState.set('routedPath', this.pathGroupName)
      this.router.navigate([`login/${this.pathGroupName}`])
    } else {
      this.router.navigate([''])
    }
  }
  
  
  setImageStyles() {
    // LUMBA-1396
    const data = this.themeService.themeData
    if (data?.clientBackgroundImageUrl) {
      this.backgroundStyle = {'background-image': `url(${data.clientBackgroundImageUrl})`}
    }
    if (data?.clientLogoImageUrl) {
      this.imageStyle = {'background-image': `url(${data.clientLogoImageUrl})`}
      this.clientLogoImageUrlNew = data.clientLogoImageUrl
    }
  }
  setClientBackground() {
    const data = this.themeService.themeData
    if (data?.clientBackgroundImageUrl) {
      this.clientBackgroundImageUrl = data.clientBackgroundImageUrl
    }
    if (data?.clientLogoImageUrl) {
      this.clientLogoImageUrlNew = data.clientLogoImageUrl
    }
  }



   private setStyles() {
    if (this.client.backgroundImageUrl) {
      this.backgroundStyle = {'background-image': `url(${this.client.backgroundImageUrl})`}
      localStorage.setItem('clientBackgroundImageUrl', this.client.backgroundImageUrl)
    }
    if (this.client.imageUrl??this.client.backgroundImageUrl) {
      this.clientLogoImageUrlNew = this.client.imageUrl??this.client.backgroundImageUrl
      this.imageStyle = {'background-image': `url(${this.client.imageUrl??this.client.backgroundImageUrl})`}
      localStorage.setItem('clientLogoImageUrlNew', this.client.imageUrl??this.client.backgroundImageUrl)
    }
  }


  // LUMBA-982
  goToLogin() {
    this.appState.set('signUpForm', undefined)
    this.router.navigate(['login'])
  }
  getPathsFromCohortForWeb() {
    this.filteredPathsGroups = [];
        this.pathGroups.forEach(path => {
          this.client =path?.client;
            // const matchingPaths = group.paths.map(path => {
            //     return path;
            // });
            if (path?.id) {
              this.filteredPathsGroups.push(path
                // {
                    // id: group?.id,
                    // groupName: group?.name,
                    // paths: path
                // }
              );
            }
        });
    
    // console.log('filtered path group', this.filteredPathsGroups);
    return this.filteredPathsGroups;
  }
  async openModal(){
    this.modalClosed = false
    const modal = await this.modalController.create({
      component: AlertPathSelectV2Component,
      cssClass: 'select-path-model-custom',
      showBackdrop:false,
      componentProps: {
        data: this.filteredPathsGroups,
      },
      enterAnimation: this.animationService.slideLeftTopEnterAnimation ,
    });
    
    modal.onDidDismiss().then((result) => {
      if (result.role === 'success') { 
        const selectedPath = result.data?.path; 
        this.activePathId = selectedPath?.id
        this.currentPathGroup = result.data?.pathGroup
        this.openShowVerification()
      } else {
        this.modalClosed = true
      }
    });
  await modal.present();
  }
  /**
   * Signs up, and only then puts the verification screen in front of them.
   *
   * It used to hide the form and show verification in the same breath as firing the mutation, which
   * answers later. A signup the server refused — "You can't sign up on this path #1721" — therefore
   * left the learner on a verification screen for an account that was never created, with no email
   * on it: a blank page, with the real message behind it in an alert nobody could act on.
   */
  openShowVerification() {
    this.signUp(() => {
      this.showSignUp = false;
      this.showVerification = true;
    });
  }
  resendVerificationEmail() {
    // if (!this.verifyEmail) {
    //   console.log('inside ifff')
    //   return false;
    // }
  
    this.userService.resendVerificationEmail(this.verifyEmail).then(
      (response) => {
        if (response && response.success && response.message) {
          this.toasterService.success(this.i18n.t(
            "An email has been sent to this address."
          ));
        }
        return response.data;
      },
      (error) => {
        console.log("sendForgotPassword error", error);
        this.toasterService.error(this.i18n.t("Email not found"));
      }
    );
  
    return false;
  }
  selectPath() {
    if (this.loading) {
      return
    }
    if(this.pathGroups?.length<1){
      const sf = this.signUpForm
      if (sf.passwordConfirmation === "" || sf.password === "" || sf.firstName === "" || sf.lastName === "" || sf.signupCode === "") {
        this.toasterService.warning(this.i18n.t('All fields are required'))
        return 
      }
    }
    if (this.fieldsRequired()) {      
      this.toasterService.warning(this.i18n.t('All fields are required'))
      return
    }
    if (!this.isPasswordsMatch()) { // LUMBA-1442
      this.toasterService.warning(this.i18n.t('Password confirmation doesn‘t match Password'))
      return
    }
    if(this.frmSignup.controls.password.status === "INVALID"){
      this.toasterService.warning(this.i18n.t('Please enter a valid password'))
      return
    }
    const clientSubDomain = this.themeService.getSubDomain() // LUMBA-1408
    // this.spinnerService.on()
    console.log('this.signUpForm.password :', this.signUpForm.password);
    this.signUpForm.password = this.singinService.removeWhiteSpaces(this.signUpForm.password)

    if (this.isSignupCode()) {
      this.userService.pathsBySignupCode(this.signUpForm.signupCode)
      .subscribe(result => {
        this.spinnerService.off()
        const paths = result.paths
        const errors = result.errors
        if(paths.length < 1 && errors.length > 0){
          this.showAlert()
        }
        this.loading = true
        this.appState.set('SignupCodePaths', paths)
        // Not through pathGroup: Kyper Cycles have none, so this threw for every one of them and
        // took the whole signup-code branch with it. The query asks for the path's own client now.
        this.client = paths[0]?.client ?? paths[0]?.pathGroup?.client
        this.activePathId = paths[0]?.id
        this.appState.set('activePathId', this.activePathId)
        if (paths[0]) {
          this.signUp()
          return
        }else if (errors && errors.length > 0) {
          const messages = errors.map(e => (e))
          this.loading = false
          return
        }
      },
        (error) => {
        this.spinnerService.off()
      })
    } else {
      // NULL isCohort means "never set" and is treated as on, same as the rest of the app; only false is off.
      this.isCohort = !!this.pathGroups?.[0] && this.pathGroups[0].client?.isCohort !== false
      if(!this.isCohort) {
        const clientPaths =this.getPathsFromCohortForWeb()
        if (!this.isMobile) {
          this.openModal()
        }
        else {
          this.appState.set('clientPathGroups', clientPaths)
          this.appState.set('signupData', JSON.stringify(this.signUpForm))
          this.router.navigate(
            ['path-select'],
            {
              queryParams: {
                origin: 'signup',
              },
          })
        }
      }else {
        this.userService.seriesByClientEmail(this.signUpForm.email, this.clientId, clientSubDomain, this.onCordova)
        .subscribe(result => {
          this.spinnerService.off()
          const clientPathGroups = result.paths
          // A real errors field at last: the list query returned a bare array, so the `.errors` this
          // branch has always read was undefined and the message never reached anyone.
          const errors = result.errors
          this.rememberSeriesGrouping(result)
          this.loading = true
          this.appState.set('clientPathGroups', clientPathGroups)
          // `!errors` no longer says "no errors": this query always answers with an array, and an
          // empty one is truthy — so a single-Cycle client stopped signing up straight through and
          // was sent to pick from a list of one.
          if (clientPathGroups.length < 2 && !(errors && errors.length > 0)) {
            // Nobody picks for them, so the one Cycle on offer is the choice. signUp reads both.
            const only = clientPathGroups[0]
            this.activePathId = only?.id ?? this.activePathId
            this.client = only?.client ?? this.client
             this.appState.set('activePathId', this.activePathId)
            this.signUp()
            return
          } else if (errors && errors.length > 0) {
            // Same again: alone, the alert says nothing on web.
            const messages = errors.map(e => (e))
            this.notificationService.alert(messages.join('<br>'), 'Oops!', {'enableHtml': true})
            this.toasterService.error(messages.join(' '))
            this.loading = false
            return
          }
          this.appState.set('signupData', JSON.stringify(this.signUpForm))
          this.router.navigate(
            ['path-select'],
            {
              queryParams: {
                origin: 'signup',
              },
            })
        },
        error => {
          this.spinnerService.off()
          this.loading = false
          const messages = error.graphQLErrors.map(e => e.message)
          this.notificationService.alert(messages.join('<br>'), 'Oops!')
          this.toasterService.error(messages.join(' '))
        })
      }

   }

  }

  /**
   * `onCreated` runs only when the server actually made the account — see openShowVerification.
   */
  signUp(onCreated?: () => void) {
    const params = {
      clientId: this.client.id,
      activePathId: this.activePathId,
      fromMobile: this.onCordova// LUMBA-982
    }
    console.log('------this.activePathId------',this.activePathId)
    this.userService.signUp(new User(Object.assign(params, this.signUpForm)))
      .subscribe(result => {
        this.spinnerService.off()
        this.signUpByForm = result.data
          const user = this.signUpByForm?.signUpByForm?.user
          const errors = this.signUpByForm?.signUpByForm?.errors
          this.loading = false
          if (user && !errors) {
            this.appState.set('verifyEmail', this.signUpForm.email)
            // Whatever the caller wanted to show once there is an account to show it for.
            onCreated?.()
            this.goToLogin()
          } else if (errors && errors.length > 0) {
            console.log(errors)
            const messages = errors.map(e => this.i18n.t(e))
            this.notificationService.alert(messages.join('<br>'), 'Oops!', {'enableHtml': true})
            // The server's own words, untranslated: "You can't sign up on this path #1721" names
            // the path, and a catalogue entry would only blur it.
            this.signUpRefused(errors)
          } else {
            // No user and no message: nothing was created and nothing said why. Treated as a
            // refusal rather than left as a screen that does nothing.
            this.signUpRefused([], 'no_user_no_error')
          }
        },
        error => {
          this.spinnerService.off()
          this.loading = false
          const messages = (error?.graphQLErrors || []).map(e => e.message)
          this.notificationService.alert(messages.join('<br>'), 'Oops!')
          this.signUpRefused(messages, 'request_failed')
        })
  }

  /**
   * Puts the learner back on the signup form, with the reason where they will see it.
   *
   * The alert above is a modal the flow can bury — on web the Cycle picker is itself a modal — so
   * the same message goes out as a toast, and the screen is returned to the form rather than left
   * on whatever the flow had moved on to.
   */
  private signUpRefused(messages: string[], reason: string = 'rejected'): void {
    const text = (messages || []).filter(Boolean).join(' ');
    this.toasterService.error(text || this.i18n.t('We could not complete your signup. Please try again.'))

    // Which Cycle was refused matters more than the count: "#1721" in the message and the path id
    // beside it are what makes a failed signup diagnosable without asking the learner.
    mixpanel.track('Signup failed', {
      reason,
      message: text,
      errors: messages || [],
      clientId: this.client?.id ?? null,
      activePathId: this.activePathId ?? null,
      signupCode: this.signUpForm?.signupCode || null,
      fromMobile: this.onCordova,
    });

    this.loading = false
    this.showVerification = false
    this.showSignUp = true
    this.modalClosed = true
  }

  fieldsRequired() {
    const sf = this.signUpForm
    if (sf.passwordConfirmation === "" || sf.password === "" || sf.firstName === "" || sf.lastName === "") {
      return true
    }
  }

  isPasswordsMatch() {
    return this.signUpForm.password === this.signUpForm.passwordConfirmation
  }

  isSignupCode(){
    console.log('----isSignupCode-----',this.signUpForm.signupCode)
    return this.signUpForm.signupCode != ''
  }

  selectActivePath(event) {
    console.log(event, this.signUpForm)
  }

  open(url: string) {
    this.cordovaService.openLinkInBrowser(
      'https://docs.google.com/viewer?url=http://www.africau.edu/images/default/sample.pdf&embedded=true'
    )
  }

  getclientIdURL(){
    this.clientId = this.route.snapshot.params.pathId
  }

  openLink(url: string) {
    if (this.cordovaService.onCordova) {
      this.cordovaService.openLinkInBrowser(url)
    }else{
      window.open(url)
    }
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }

  hideShowPassword1() {
    this.passwordType1 = this.passwordType1 === 'text' ? 'password' : 'text';
    this.passwordIcon1 = this.passwordIcon1 === 'eye-off' ? 'eye' : 'eye-off';
  }

  fnameInputFocus(event: FocusEvent){
    this.isFname = true
    this.isPwd  = false
    this.fnameInputFocusTab = true;
    
    const input = event.target as HTMLElement;
    this.scrollToInput(input); //

    if(this.isAndroidTablet){
      this.onTextareaFocus();
      }
  }

  fnameInputBlur(){
    if(this.signUpForm.firstName.length < 1){
      this.isFname  = false
    }
    this.fnameInputFocusTab = false
    if (this.isAndroidTablet && !this.fnameInputFocusTab && !this.lnameInputFocusTab && !this.pwdInputFocusTab && !this.passwordConfirmationTab && !this.signupCodeInputFocusTab ) {
      this.onTextareaBlur();
    }
  }

  lnameInputFocus(event: FocusEvent){
    this.isLname = true
    this.isPwd  = false
    const input = event.target as HTMLElement;
    this.scrollToInput(input);
    if(this.signUpForm.firstName.length < 1){
      this.isFname  = false
    }
    this.lnameInputFocusTab = true;
    if(this.isAndroidTablet){
      this.onTextareaFocus();
      }
  }

  lnameInputBlur(){
    if(this.signUpForm.lastName.length < 1) this.isLname  = false
    this.lnameInputFocusTab = false
    if (this.isAndroidTablet && !this.fnameInputFocusTab && !this.lnameInputFocusTab && !this.pwdInputFocusTab && !this.passwordConfirmationTab && !this.signupCodeInputFocusTab ) {
      this.onTextareaBlur();
    }
  }

  pwdInputFocus(event: FocusEvent){
    this.isPwd = true
    const input = event.target as HTMLElement;
    this.scrollToInput(input);
    if(this.signUpForm.firstName.length < 1){
      this.isFname  = false
    } 
    this.pwdInputFocusTab= true
    if(this.isAndroidTablet){
      this.onTextareaFocus();
      }   
      
  }

  pwdInputBlur(){
    if(this.signUpForm.password.length < 1) this.isPwd  = false
    this.pwdInputFocusTab= false
    if (this.isAndroidTablet && !this.fnameInputFocusTab && !this.lnameInputFocusTab && !this.pwdInputFocusTab && !this.passwordConfirmationTab && !this.signupCodeInputFocusTab ) {
      this.onTextareaBlur();
    }
  }

  confirmPwdInputFocus(event: FocusEvent){
    this.isConfirmPwd = true
    this.isConfirmPwdFocused = true
    this.isPwd  = false
    const input = event.target as HTMLElement;
    this.scrollToInput(input);
    if(this.signUpForm.firstName.length < 1){
      this.isFname  = false
    }
    this.passwordConfirmationTab = true;
    if(this.isAndroidTablet){
      this.onTextareaFocus();
      }  
  }

  confirmPwdInputBlur(){
    if(this.signUpForm.passwordConfirmation.length < 1) this.isConfirmPwd  = false
    this.isConfirmPwdFocused = false
    this.passwordConfirmationTab= false
    if (this.isAndroidTablet && !this.fnameInputFocusTab && !this.lnameInputFocusTab && !this.pwdInputFocusTab && !this.passwordConfirmationTab && !this.signupCodeInputFocusTab ) {
      this.onTextareaBlur();
    }
  }

  signupCodeInputFocus(event: FocusEvent){
    this.isSUCode = true
    this.isPwd  = false
    const input = event.target as HTMLElement;
    this.scrollToInput(input);
    if(this.signUpForm.signupCode.length < 1){
      this.isFname  = false
    }
    this.signupCodeInputFocusTab= true
    if(this.isAndroidTablet){
      this.onTextareaFocus();
      }  
  }

  signupCodeInputBlur(){
    if(this.signUpForm.signupCode.length < 1) this.isSUCode  = false
    this.signupCodeInputFocusTab= false
    if (this.isAndroidTablet && !this.fnameInputFocusTab && !this.lnameInputFocusTab && !this.pwdInputFocusTab && !this.passwordConfirmationTab && !this.signupCodeInputFocusTab ) {
      this.onTextareaBlur();
    }
  }

  checksignupcode(email, clientId, onCordova){
    const clientSubDomain = this.themeService.getSubDomain() 
    this.userService.seriesByClientEmail(email, clientId, clientSubDomain, onCordova)
    .subscribe(result => {
      this.pathGroups = result.paths
      this.rememberSeriesGrouping(result)
      // Say what the server said. "This email does not belong to any Kyper-enabled client" is the
      // whole reason the rest of the form leads nowhere, and it was read off the response and
      // dropped — so nothing was shown and the learner filled the form in anyway.
      const errors = result.errors || []
      if (errors.length > 0) {
        this.toasterService.error(errors.join(' '))
      }
    },
    error => {
      // Halts here, on the form, with the reason in view. `graphQLErrors` is missing entirely on a
      // transport failure, so reading it straight threw inside the error handler — the one place
      // nothing catches — and the learner was left on a form that had quietly given up.
      const messages = (error?.graphQLErrors || []).map(e => e.message)
      this.toasterService.error(
        messages.join(' ') || this.i18n.t('We could not check your email. Please try again.')
      )
    })
  }

  /**
   * Keeps the Series grouping beside the flat Cycle list, for the select screens to render.
   *
   * Both of them — the modal on web, the page on mobile — read `clientPathGroups` for the list
   * itself, so that stays what it was. A Cycle in two Series appears once in the list and under
   * both groups.
   */
  private rememberSeriesGrouping(result: any): void {
    this.appState.set('clientSeriesGroups', result?.series || []);
    this.appState.set('clientUngroupedPaths', result?.ungroupedPaths || []);
  }

  async presentPopover(ev: Event) {
    const dialogRef = this.matDialog.open(SignupPopoverComponent)
    dialogRef.afterClosed().subscribe((result) => {
    })
  }

  showAlert(){
    const dialogRef = this.matDialog.open(AlertWrongCodeComponent)
    dialogRef.afterClosed().subscribe((result) => {
    })
  }

  gotoNextField(nextElement, field=null) {
    if(field === 'password' && this.frmSignup.controls.password.status === "INVALID"){
      console.log('password not validated');
      this.toasterService.warning(this.i18n.t('Please enter a valid password'))
    }
    nextElement.setFocus();
  }

  createSignupForm(): UntypedFormGroup {
    return this.fb.group(
      {
        email: [
          null,
          Validators.compose([Validators.email, Validators.required])
        ],
        password: [
          null,
          Validators.compose([
            Validators.required,
            // check whether the entered password has a number
            CustomValidators.patternValidator(/\d/, {
              hasNumber: true
            }),
            // check whether the entered password has upper case letter
            CustomValidators.patternValidator(/[A-Z]/, {
              hasCapitalCase: true
            }),
            // check whether the entered password has a lower case letter
            CustomValidators.patternValidator(/[a-z]/, {
              hasSmallCase: true
            }),
            // check whether the entered password has a special character
            CustomValidators.patternValidator(
              /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/,
              {
                hasSpecialCharacters: true
              }
            ),
            Validators.minLength(7)
          ])
        ],
        confirmPassword: [null, Validators.compose([Validators.required])]
      },
      {
        // check whether our password and confirm password match
        validator: CustomValidators.passwordMatchValidator
      }
    );
  }

  onKey(event) {
    let password = event.target.value
    if(password){
      if(this.frmSignup.controls.password.status === "VALID"){
        this.passwordValidated = true
      }else if(this.frmSignup.controls.password.status === "INVALID"){
        this.passwordValidated = false
      }else{
        this.passwordValidated = false
      }
    }
  }
  
}
